import React, {useState, useEffect} from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import {toTime, toTimeType, timeConverter, isObjectEmpty, uploadCSV, replaceAll, timeConverterSM, toArray} from '../../../../Utils';
import Spinner from '../../../common/generic/Spinner';

const ContainerComp = ({pageState, reportState, csvData, setcsvData}) =>{
    const {database, deleteThis, request, fetchModules, modulesData, modulesReady } = pageState;
    const [processedMarks, setProcessedMarks] = useState({});
    const [markRecords, setMarkRecords] = useState({});
    const {selectedStudents, selectedProgram} = reportState;
    const [totals, setTotals] = useState({});
    const debugTest = false;

    /*
    CSV NOTES
    =========
    There is a big problem when trying to upload more then 1 csv file.  The below system will reset all the data in 
    this component and start it over when when the user clicks save.
    
    Steps
    1) User clicks save in either ProgramReportTableComp or AcitivityReportComp
        1b) openCSVPage() will populate csvData using setcsvData({processStage:'newRequest'});
    2) ViewReportsPage checks to see if the marks have changed (* seems to be called way to many times...)
        2b) setReportType(csvData.reportType);
            setSelectedProgram({...csvData.selectedProgram});
            setSelectedStudents([...csvData.selectedStudents]); 
    3) Start the report
        3a) CSV Step 1: checks if a new request for csv and starts to clear the data
        3b) CSV Step 2: clears the data 
        3c) CSV Step 3: keep checking to see when the data has been cleared
        3d) CSV Step 4: once the data for this component has been reset then start the normal start up process for this comp.
        3e) (The normal Startup starts at CSV Step 1) 
    */

    // CSV Step 4: once the data for this component has been reset then start the normal start up process for this comp.
    // The normal Startup starts at CSV Step 1 
    const tryLoadingCSVStage2 = () => {
        if(!csvData) return;
        if(csvData.processStage === 'clearingData'){
            if(!database['getMadMinuteMarks'] && isObjectEmpty(markRecords) && isObjectEmpty(processedMarks)){
                setcsvData({...csvData, processStage:'clearedData'});
            }
        }
    };
    // CSV Step 3: keep checking to see when the data has been cleared
    useEffect(() =>{tryLoadingCSVStage2();},[database['getMadMinuteMarks']]);
    useEffect(() =>{tryLoadingCSVStage2();},[markRecords]);
    useEffect(() =>{tryLoadingCSVStage2();},[processedMarks]);

    // CSV Step 2: clears the data
    useEffect(() => {
        if(!csvData) return;

        if(csvData.processStage === 'clearingData'){
            deleteThis('getMadMinuteMarks');
            setMarkRecords({});
            setProcessedMarks({});
        }
    },[csvData]);

    // CSV Step 1: checks if a new request for csv and starts to clear the data 
    // Normal Startup Step 1:
    useEffect(() => {
        if(csvData){
            if(csvData.processStage==='newRequest'){
                // csvData.setloadingCSV({...csvData.loadingCSV, MMStatusMonth:true});
                setcsvData({...csvData, processStage:'clearingData'});
                return;
            }

            if(csvData.processStage==='clearingData') return;
        }

        if(!isObjectEmpty(markRecords)) return; // already loading

        if(!database['getMadMinuteMarks']){
            let studentQueries = selectedStudents.map(studentRec=>{
                let getMarksQuery={
                    params: studentRec.id,
                    func:'getMadMinuteMarks'            
                };
                return getMarksQuery;
            });

            if(studentQueries.length > 0){
                let counter = 1;
                studentQueries = studentQueries.map((query,i)=>{
                    let prevQuery = (i!=0) ? studentQueries[i-1] : 'undefinded';
                    if(prevQuery !== 'undefinded'){
                        counter++;
                        query.nextRequest = prevQuery;
                    }
                    return query;
                });
                let loadChainedMarks = studentQueries[studentQueries.length-1];
                loadChainedMarks.numQueries = counter;
                setMarkRecords({info:{numStudents:counter,numLoaded:counter}});

                // pass the link list of saved changes into the database
                request(loadChainedMarks); 
            }
            else
                console.log('Nothing to load?');
        }
    });

    // convert database['getMadMinuteMarks'] into setMarkRecords
    // UDATES - when database['getMadMinuteMarks'] changes
    useEffect(() => {
        if(csvData && csvData.processStage !== 'clearedData') return; // don't setup markRecords for csv files without being ready 
        if(isObjectEmpty(markRecords)) return;
        (!pageState.isFetchingModules && !modulesReady) && fetchModules(selectedProgram.id.toLowerCase());
        if(!database['getMadMinuteMarks']) return;
        
        let marks = {};
        let key = 'unavailable';
        let counter = {...markRecords.info}; // <---  Mast clone this or not all marks are reported due to a race condition with tryLoadingNow creating a proceed Mark before its time

        if(database['getMadMinuteMarks'].isLoaded) counter.numLoaded--;
            if(debugTest) console.log('counter = ',counter.numLoaded,database['getMadMinuteMarks']);
        marks = {
            isloaded: database['getMadMinuteMarks'].isLoaded,
            data: database['getMadMinuteMarks'].data
        }; 

        if((marks.data) && !isObjectEmpty(marks.data)){
            key = Object.keys(marks.data)[0].split('+')[0];
        }

        let newMarkRecords = {...markRecords, info:{...counter}, [key]:marks};
            if(debugTest) console.log('setMarkRecords',{...markRecords}, newMarkRecords);
        //delete marks.data;
        setMarkRecords(newMarkRecords);

    }, [database['getMadMinuteMarks']]); 

    const tryLoadingNow = () => {
            if(debugTest) console.log('tryLoadingNow');
        if(isObjectEmpty(markRecords)) return;
            if(debugTest) console.log('has Mark Records',{...markRecords.info});
            if(debugTest) console.log('processedMarks',{...processedMarks});
        if(!isObjectEmpty(processedMarks)) return;
            if(debugTest) console.log('There are no processed Marks');
        if(markRecords.info.numStudents > 0 && markRecords.info.numLoaded > 0) return;
            if(debugTest) console.log('Create Processed Marks');

        let reportData = JSON.parse(localStorage.getItem('reportData'));
        let masterLevel = parseInt(reportData.masterLevel)/100;

            if(debugTest) console.log('markRecords',markRecords);
        let studentMarks = selectedStudents.reduce((acc,studentRec)=>{
            let studentID = studentRec.id;
            let studentMarkRecords = markRecords[studentID];
            if(!studentMarkRecords) return acc; // still loading marks

            let mergedMarks = toArray(studentMarkRecords.data).reduce((markAcc, markRecord)=>{ 
                let now = new Date().getTime();
                let date30DaysAgo = now - (30 * 86400000);
                if(markRecord.DayDate && parseInt(markRecord.DayDate) > date30DaysAgo){

                    const addMark = (fact) =>{
                        //console.log('markRecord[`${fact}QuestionsRight`]',markRecord,`markRecord[${fact}Drills]`);
                        if(markRecord[`${fact}Drills`]){
                            markAcc.Correct += parseInt(markRecord[`${fact}QuestionsRight`]);
                            markAcc.Drills += parseInt(markRecord[`${fact}Drills`]);
                            markAcc.Mastered += parseInt(markRecord[`${fact}Mastered`]);
                            markAcc.Questions += parseInt(markRecord[`${fact}QuestionsAttempted`]);
                            markAcc.AllPerMinute += parseInt(markRecord[`${fact}QuestionsAttempted`]);
                            markAcc.numRecords++;
                            markAcc.Accuracy = Math.round((markAcc.Correct / markAcc.Questions) * 100);
                            if(!markAcc.Fact.includes(fact))
                                markAcc.Fact = markAcc.Fact + ' ' + fact;
                            if(markAcc.CurrentFact.fact && markAcc.CurrentFact.dayDate < markRecord.DayDate)
                                markAcc.CurrentFact = {fact:fact, dayDate:markRecord.DayDate};                                
                            if(!markAcc.CurrentFact.fact)
                                markAcc.CurrentFact = {fact:fact, dayDate:markRecord.DayDate};
                        }
                    };
                    addMark('ADD', 'Add');
                    addMark('SUB', 'Sub');
                    addMark('MULT','Mult');
                    addMark('DIV', 'Div');
                    markAcc.AllPerMinuteAvg = Math.round(markAcc.AllPerMinute / markAcc.numRecords);
                }

                return markAcc;
            },{Correct:0, Drills:0, Mastered:0, Questions:0, AllPerMinute:0, numRecords:0, AllPerMinuteAvg:0, Accuracy:0, Fact:'', CurrentFact:{}});

                if(debugTest) console.log(`${studentRec.id}+${studentRec.name} `,mergedMarks);
            mergedMarks.Name = studentRec.name;
            acc[`${studentRec.id}+${studentRec.name}`] = mergedMarks;
            return acc;
        },{});
        setProcessedMarks(studentMarks);

        let studentTotals = {NumAvgRecords: 0, Drills:0, Mastered:0, AllPerMinuteAvg:0, Accuracy:0, Drills:0, AllPerMinute:0, numRecords:0, Correct:0, Questions:0};

        Object.keys(studentMarks).map((key) => {
            let markRec = studentMarks[key];
            studentTotals.Drills += parseInt(markRec.Drills);
            studentTotals.Mastered += parseInt(markRec.Mastered);
            studentTotals.AllPerMinute += parseInt(markRec.AllPerMinute);
            studentTotals.numRecords += parseInt(markRec.numRecords);
            studentTotals.Correct += parseInt(markRec.Correct);
            studentTotals.Questions += parseInt(markRec.Questions);
            studentTotals.AllPerMinuteAvg += parseInt(markRec.AllPerMinuteAvg); 
            studentTotals.Accuracy += parseInt(markRec.Accuracy); 
            studentTotals.NumAvgRecords ++;
        });     
        studentTotals.AllPerMinuteAvg = Math.round(studentTotals.AllPerMinuteAvg / studentTotals.NumAvgRecords);
        studentTotals.Accuracy = Math.round(studentTotals.Accuracy / studentTotals.NumAvgRecords);
        setTotals(studentTotals);    

        if(csvData){
            let newLine = '%0A';
            let csvString = '';
            csvString +=`"Student without marks will not appear in this report"${newLine}`;          

            let headerStr = `${newLine}"${selectedProgram.name}"${newLine}"Last 30 Days"${newLine}`;
            let tableHeaderStr = '"Student","Current","Operations","Drills","Mastered Facts","Questions per Minute","Accuracy"'+newLine;
            csvString += headerStr + tableHeaderStr;

            Object.keys(studentMarks).forEach((key) => { 
                let tableData  = studentMarks[key];
                let student = key.split('+')[1];
                const { AllPerMinuteAvg, Drills, Mastered, Accuracy, Fact, CurrentFact } = tableData;                   
                let recordStr = `"${student}","${CurrentFact.fact}","${Fact}","${Drills}","${Mastered}","${AllPerMinuteAvg}","${Accuracy}"${newLine}`;
                csvString += recordStr;
            });
            
            let recordStr = `"Totals","","","${studentTotals.Drills}","${studentTotals.Mastered}","${studentTotals.AllPerMinuteAvg}","${studentTotals.Accuracy}"${newLine}`;
            csvString += recordStr;           

            let name = '';
            if(Object.keys(studentMarks).length===0){
                window.alert('There are no marks for the student(s) selected');
                csvData.setloadingCSV({...csvData.loadingCSV, MMStatusMonth:false});
                return;
            }

            if(Object.keys(studentMarks).length===1)
                name = Object.keys(studentMarks)[0].split('+')[1]+'_';

            let today = new Date();
            today = timeConverterSM(today.getTime());

            uploadCSV(name+'Last30DayReport_'+selectedProgram.name+'_'+today,csvString);
            csvData.setloadingCSV({...csvData.loadingCSV, MMStatusMonth:false});
        }
    }; 
    //useEffect(() =>{tryLoadingNow();},[modulesData]);
    useEffect(() =>{tryLoadingNow();},[markRecords]);

    if(csvData) return <></>;
    if(isObjectEmpty(markRecords)) return <> <Spinner/> <center>Loading... ({database['queryCount']}) </center> </>;
    if(markRecords.info.numStudents > 0 && markRecords.info.numLoaded > 0) return <> <Spinner/> <center>Loading... ({database['queryCount']}) </center> </>;

    const headerComp = <center>
    <h4><Row>
        <Col xs='4'></Col>
        <Col xs='4'>{selectedProgram.name} </Col>
        <Col xs='4'>Last 30 Days</Col>
    </Row></h4>
    </center>;

    const titleRow = <Row style={{ fontSize:'0.9em', fontWeight:'bold'}}>
    <Col xs='12'><Row>
        <Col style={{textAlign: 'center'}} xs='2'>Student</Col>
        <Col style={{textAlign: 'center'}} xs='1'>Current</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Operations</Col>
        <Col style={{textAlign: 'center'}} xs='1'>Drills</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Mastered Facts</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Questions per Minute</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Accuracy</Col>
        </Row></Col>
    </Row>;

    return <>
        {Object.keys(processedMarks).length < selectedStudents.length && <center> <p>  Students without marks will not appear in this report </p></center>}
        <br/>
        {!isObjectEmpty(processedMarks) && <>
            {headerComp}
            <hr/>
            {titleRow}

            {/* reorder marks into alphabetical order but for some reason this is not needed?
                {toArray(processedMarks)
                .sort((a,b) => (a.Name.toUpperCase() > b.Name.toUpperCase()) ? 1 : (a.Name.toUpperCase() === b.Name.toUpperCase() ? -1 : 0))
                .map((e, i) => (
                    <StudentRow  key={i} name={e.Name} tableData={e}/> 
                ))
            } */}

            {Object.keys(processedMarks).map((key, i) => (
                <StudentRow  key={i} name={key.split('+')[1]} tableData={processedMarks[key]}/> 
            ))}

            <Row style={{fontSize:'0.9em', fontWeight:'bold'}}>        
                <Col style={{textAlign: 'center'}} xs='2'> </Col>
                <Col style={{textAlign: 'center'}} xs='1'> </Col>
                <Col style={{textAlign: 'center'}} xs='2'>  </Col>
                <Col style={{textAlign: 'center'}} xs='1'>{totals.Drills}</Col>
                <Col style={{textAlign: 'center'}} xs='2'>{totals.Mastered}</Col>
                <Col style={{textAlign: 'center'}} xs='2'>{totals.AllPerMinuteAvg}</Col>
                <Col style={{textAlign: 'center'}} xs='2'>{totals.Accuracy}%</Col>
            </Row>        
        </>}
    </>;
};

const StudentRow = ({name, tableData}) => {

    const { AllPerMinuteAvg, Drills, Mastered,  Accuracy, Fact, CurrentFact } = tableData;
    
    return (
        <Row style={{fontSize:'0.9em'}}>        
            <Col style={{textAlign: 'center'}} xs='2'> {name} </Col>
            <Col style={{textAlign: 'center'}} xs='1'>{CurrentFact && CurrentFact.fact && CurrentFact.fact}</Col>
            <Col style={{textAlign: 'center'}} xs='2'> {Fact} </Col>
            <Col style={{textAlign: 'center'}} xs='1'>{Drills}</Col>
            <Col style={{textAlign: 'center'}} xs='2'>{Mastered}</Col>
            <Col style={{textAlign: 'center'}} xs='2'>{AllPerMinuteAvg}</Col>
            <Col style={{textAlign: 'center'}} xs='2'>{Accuracy}%</Col>
        </Row>
    );
};

export default ContainerComp;